import { makeRequestAction } from './index';

export const importBrokerListings = makeRequestAction('IMPORT_BROKER_LISTINGS', {
  onSuccess(params, response) {
    return {
      response,
    };
  },
});
